import React, { useState, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCommon } from "../../Hooks/Common/useCommon";
import { AgGridReact } from "@ag-grid-community/react";
import DatePicker from "react-multi-date-picker";
import { Calendar } from "primereact/calendar";
import { SkeletonDataTable } from "../Loader/Loader";
import RequestPopup from "./RequestPopup";
import { useProjectAccessRequestList } from "../../Hooks/Features/HelpDesk/useProjectAccessRequestList";
import { expriryData, handleDurationSelect } from "../../utils/Helper";
import { Dialog } from "primereact/dialog";
import _ from "underscore";
import CommonFilterDropdown from "../CommonCompo/CommonFilterDropdown/CommonFilterDropdown";

const ProjectAccessRequestList = () => {

    const { loader, tagRef, columnDefs, filterValues, setFilterValues, getRequestedData, rowData, showRequestPopup, setShowRequestPopup, dropDownOption, handleStatusChange, editData, setEditData, handleRequest, showInfo, approval, setApproval, showApprovePopup, setShowApprovePopup } = useProjectAccessRequestList();
    const { checkPermission } = useCommon();
    const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
    const datePickerRef = useRef(null);

    return (
        <div ref={() => checkPermission("help desk", tagRef)}>
            <div ref={tagRef} id='{"tabname": "helpdesk", "data": "helpdesk_li"}' >
                <div className="d-flex align-items-center justify-content-between gap-3 w-100 mt-2 mb-3">
                    <div className="d-flex align-items-center gap-2 flex-grow-1">
                        <h5 className="mb-0">Project Access Request</h5>
                    </div>
                    <div className="d-flex justify-content-end align-items-center gap-2">
                        <button className="sk-btn sk-btn-primary" onClick={() => getRequestedData()} title="Refresh">
                            <FontAwesomeIcon icon="fa-solid fa-arrows-rotate" />
                        </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowFiltersDrawer(true)} title="Filters">
                            <FontAwesomeIcon icon="fa-solid fa-filter" />
                        </button>
                        <button className="sk-btn sk-btn-primary" onClick={() => setShowRequestPopup(true)} title="Add Request">
                            <FontAwesomeIcon icon="fa-solid fa-plus" />
                        </button>
                    </div>
                </div>


                {loader ? <div><SkeletonDataTable numSkeletons={15} /></div> :
                    <div className="ag-theme-alpine" style={{ height: "calc(100vh - 110px)" }}>
                        <AgGridReact
                            rowData={rowData}
                            columnDefs={columnDefs}
                            rowHeight={30}
                            headerHeight={30}
                        />
                    </div>
                }
                {
                    showRequestPopup && <RequestPopup showRequestPopup={showRequestPopup} setShowRequestPopup={setShowRequestPopup} editData={editData} setEditData={setEditData} callApi={getRequestedData} type="project_access_tab" />
                }

                <Dialog visible={showApprovePopup} header="Approve Request" onHide={() => {
                    setShowApprovePopup(false);
                }} className="modal-small" draggable={false}>
                    <div>
                        <div className="dialog-content">
                            <div className="d-flex gap-4  mt-2">
                                <div className='w-50 inspectra-calendar'>
                                    <label>Expiry Date</label>
                                    <Calendar
                                        className="input-dd"
                                        dateFormat='dd-mm-yy'
                                        style={{ height: "100%" }}
                                        placeholder="Expiry Date"
                                        name='to_date'
                                        value={approval?.expiry_date}
                                        onChange={(e) => setApproval((prev) => ({ ...prev, expiry_date: e.target.value, selectedRadio: "" }))}
                                        minDate={new Date()}
                                        maxDate={
                                            approval?.exp_days > 0
                                                ? new Date(new Date().setDate(
                                                    new Date().getDate() + approval?.exp_days
                                                ))
                                                : new Date(new Date().setDate(
                                                    new Date().getDate() + 15
                                                ))
                                        }
                                    />
                                </div>
                            </div>
                            <div className="d-flex align-items-center text-center my-2" >
                                <hr style={{ flex: 1, }} className="border-top border-secondary" />
                                <span style={{ padding: '0 10px', color: '#666' }}>OR</span>
                                <hr style={{ flex: 1, }} className="border-top border-secondary" />
                            </div>
                            <div>
                                <div className="">
                                    Expiry Duration
                                </div>
                                {expriryData.filter((d) => {
                                    if (approval?.exp_days <= 15) {
                                        return d.value !== "1month" && d.value !== "3months";
                                    }
                                    if (approval?.exp_days < 90) {
                                        return d.value !== "3months";
                                    }
                                    return true;
                                }).map((d) => (
                                    <div className="form-check-inline" key={d.value}>
                                        <input
                                            type="radio"
                                            id={d.value}
                                            name="duration"
                                            value={d.value}
                                            checked={d.value === approval?.selectedRadio}
                                            onChange={(e) =>
                                                setApproval((prev) => ({
                                                    ...prev,
                                                    expiry_date: handleDurationSelect(d.value),
                                                    selectedRadio: d.value
                                                }))
                                            }
                                        />
                                        <label htmlFor={d.value} className="sk-radio-label">
                                            {d.label}
                                        </label>
                                    </div>
                                ))
                                }
                            </div>
                        </div>
                    </div>

                    <div className="d-flex gap-2 justify-content-center my-4" >
                        <button className="sk-btn text-white bg-black sk-btn-primary"
                            onClick={() => handleRequest(null,approval?.data)}
                        > Confirm </button>
                        <button
                            onClick={() => {
                                setShowApprovePopup(false)
                            }}
                            className="sk-btn sk-btn-primary">
                            Cancel
                        </button>
                    </div>
                </Dialog>

                {/* Right Panel Filters Drawer */}
                <div className={`sk-drawer-overlay ${showFiltersDrawer ? 'active' : ''}`} onClick={(e) => { if (e.target === e.currentTarget) setShowFiltersDrawer(false); }}>
                    <div className={`sk-drawer-panel ${showFiltersDrawer ? 'open' : ''}`}>
                        <div className="sk-drawer-header">
                            <h5 className="sk-drawer-title">Filters</h5>
                            <div className="d-flex align-items-center gap-2">
                                <button className="sk-drawer-clear-btn" onClick={() => {
                                    setFilterValues((prev) => ({
                                        ...prev,
                                        hoveredRange: [],
                                        projects: [],
                                        all_users: [],
                                        project_role: [],
                                        project_request_type: [],
                                        status: dropDownOption?.statusOptions?.[0],
                                        apiCall: true
                                    }));
                                }}>Clear All</button>
                                <button className="sk-drawer-close-btn" onClick={() => setShowFiltersDrawer(false)}>
                                    <FontAwesomeIcon icon="fa-solid fa-xmark" />
                                </button>
                            </div>
                        </div>
                        <div className="sk-drawer-body">
                            <div className='d-flex flex-column gap-4'>
                                {/* Date Picker Filter */}
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Date Range</div>
                                    <DatePicker
                                        ref={datePickerRef}
                                        value={filterValues?.hoveredRange}
                                        onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setFilterValues((prev) => ({ ...prev, hoveredRange: e, isChange: true }));
                                            if (e && e.length === 2) {
                                                datePickerRef.current?.closeCalendar();
                                            }
                                            }
                                        }}
                                        range
                                        rangeHover
                                        style={{ width: "100%" }}
                                        containerStyle={{ width: "100%" }}
                                        inputClass="w-100 sk-input-dd"
                                        placeholder="Select Date"
                                    />
                                </div>

                                {/* CommonFilterDropdown */}
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Dimensions</div>
                                    <CommonFilterDropdown
                                        fields={[
                                            { key: "projects", label: "Projects", col: 12 },
                                            { key: "all_users", label: "Users", col: 12 },
                                            { key: "project_role", label: "Project Role", col: 12 },
                                            { key: "project_request_type", label: "Type", col: 12 }
                                        ]}
                                        filterValues={filterValues}
                                        setFilterValues={setFilterValues}
                                    />
                                </div>

                                {/* Status Filter */}
                                <div className="sk-drawer-filter-group">
                                    <div className="task-list-filter-label">Status</div>
                                    <div className='sk-segment-control mb-3'>
                                        {dropDownOption?.statusOptions?.map((item) => (
                                            <button
                                                key={item.request_status_id}
                                                type="button"
                                                className={`sk-segment-btn ${filterValues.status?.request_status_id === item.request_status_id ? 'active' : ''}`}
                                                onClick={() => handleStatusChange({ target: { value: item.request_status_id } })}
                                            >
                                                {item.request_status_name}
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="sk-drawer-footer">
                            <button className="sk-btn .sk-btn-primary-filter w-100 py-2" onClick={() => {
                                getRequestedData();
                                setShowFiltersDrawer(false);
                            }}>Apply Filters</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProjectAccessRequestList